/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Remove_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove project share. {message}" |
*
* @param {Team_Share_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_remove_error = /** @type {((inputs: Team_Share_Remove_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Remove_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la suppression du partage du projet. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektfreigabe konnte nicht entfernt werden. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile rimuovere la condivisione del progetto. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить долю проекта. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar el recurso compartido del proyecto. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除项目共享失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクト共有を削除できませんでした。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट शेयर हटाने में विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao remover o compartilhamento do projeto. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to remove project share. ${i?.message}`)
});